import { render, staticRenderFns } from "./ReturnFreeMerchants.vue?vue&type=template&id=4174d606&"
import script from "./ReturnFreeMerchants.vue?vue&type=script&lang=js&"
export * from "./ReturnFreeMerchants.vue?vue&type=script&lang=js&"
import style0 from "./ReturnFreeMerchants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports